import React, { ComponentType } from 'react';
import { EmptyStateProps } from '@wix/design-system';
import { useCollectionContext } from '../CollectionContext';
import { CollectionEmptyStateBase } from '../CollectionEmptyStateBase';

export interface CollectionEmptyStateProps extends EmptyStateProps {
  component?: ComponentType<EmptyStateProps>;
}

/**
 * @deprecated
 */
export function CollectionEmptyState(props: CollectionEmptyStateProps) {
  const state = useCollectionContext();

  return <CollectionEmptyStateBase state={state} {...props} />;
}
